import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const LightspeedIcon = (props: IconProps) => (
  <Icon
    width={24}
    height={24}
    viewBox="0 0 30 44"
    fill="none"
    title={t`Lightspeed`}
    {...props}
  >
    <Path
      d="M14.4991 -0.000183105L16.5598 3.53158C17.0014 4.26737 17.0014 5.15031 16.5598 5.8861L4.48956 26.7824L10.0831 36.6419C10.9663 38.2607 12.5855 39.1436 14.3519 39.1436C16.1182 39.1436 17.7374 38.1135 18.7678 36.6419L24.5086 26.7824L23.0366 24.1336L16.5598 35.3175C16.1182 36.0533 15.3822 36.4948 14.4991 36.4948C13.6159 36.4948 12.8799 36.0533 12.4383 35.3175L7.58073 26.7824L18.7678 7.35767L20.8286 10.8894C21.2702 11.6252 21.2702 12.5082 20.8286 13.244L13.0271 26.7824L14.4991 29.4313L23.0366 14.7155L28.6301 24.4279C29.5133 25.8994 29.5133 27.8125 28.6301 29.2841L23.0366 39.1436C22.1534 40.6151 19.5038 43.9998 14.6463 43.9998C9.7887 43.9998 7.13913 40.6151 6.25594 39.1436L0.662394 29.2841C-0.220798 27.8125 -0.220798 25.8994 0.662394 24.4279L14.4991 -0.000183105Z"
      fill="#E81C1C"
    />
  </Icon>
);

export default LightspeedIcon;
